import(/* webpackMode: "eager", webpackExports: ["LandingAppLoader"] */ "/app/apps/frontend/components/landing-app-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SSRReplacer"] */ "/app/apps/frontend/components/ssr-replacer.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/frontend/node_modules/next/dist/client/app-dir/link.js");
